import {
  SET_JOURNAL_PRIVACY_REQUESTED,
  SET_JOURNAL_PRIVACY_FAILURE,
  SET_JOURNAL_PRIVACY_SUCCESS,
} from 'actiontypes/myself';
import MyselfService from 'services/MyselfService';
import { IMyselfService } from 'types/myself';
import { Dispatch } from 'redux';

/** ----------------------------------------------------------------------------
 * Set Journal Privacy
 -----------------------------------------------------------------------------*/
export default setJournalPrivacy(new MyselfService());

export function setJournalPrivacy(service: IMyselfService) {
  return (isPrivate: boolean) => async (dispatch: Dispatch) => {
    dispatch(setJournalPrivacyRequested());

    try {
      const { data } = await service.setJournalPrivacy(isPrivate);
      dispatch(setJournalPrivacySuccess(data));
    } catch (error) {
      console.error('error in setJournalPrivacy');
      console.error(error);
      dispatch(setJournalPrivacyFailure(error));
    }
  };
}

const setJournalPrivacyRequested = () => ({
  type: SET_JOURNAL_PRIVACY_REQUESTED,
  isSuccess: false,
});

const setJournalPrivacySuccess = ({ journalIsPrivate }: { journalIsPrivate: boolean }) => ({
  type: SET_JOURNAL_PRIVACY_SUCCESS,
  isSuccess: true,
  payload: { journalIsPrivate },
});

const setJournalPrivacyFailure = (error: any) => ({
  type: SET_JOURNAL_PRIVACY_FAILURE,
  status: error.response && error.response.status,
});
